module.exports = __webpack_public_path__ + "img/compy.df8ab053.png";